/** @format */

// @format
import { mapGetters } from 'vuex';
import { ORDER_STATUS } from '@tenant/app/utils/constants/orderStatus';

export default {
    data() {
        return {
            defaultStatus: ORDER_STATUS.PENDING.value,
        };
    },
    computed: {
        ...mapGetters({
            bookingStatus: 'booking/getStatus',
            orderStatus: 'booking/getOrderStatus',
            isPastBooking: 'booking/isPastBooking',
        }),
        isOrderRefunded() {
            return this.orderStatus === ORDER_STATUS.REFUNDED.value;
        },
        isStatusConfirmed() {
            return this.bookingStatus === ORDER_STATUS.RESERVED.value;
        },
        isStatusPending() {
            return !this.isStatusConfirmed || !this.isStatusFailed;
        },
        isStatusFailed() {
            return this.bookingStatus === ORDER_STATUS.FAILED.value;
        },
        isStatusDeleted() {
            return this.bookingStatus === ORDER_STATUS.DELETED.value;
        },
        // Refund Requested - OrderStatus.REFUNDED + OrderPartnerStatus.FAILED
        isStatusRefunded() {
            return this.isOrderRefunded && this.isStatusFailed;
        },
        // Canceled booking - OrderStatus.REFUNDED + OrderPartnerStatus.DELETED
        isStatusCanceled() {
            return this.isOrderRefunded && this.isStatusDeleted;
        },
    },
};
